<template>
  <div class="damage-claim">
    <div
      v-if="successfullySubmitted"
      class="alert alert-success"
    >
      <div class="container">
        You have successfully submitted your evidence.
      </div>
    </div>
    <form
      v-else
      class="damage-claims-new"
      enctype="multipart/form-data"
      @submit.prevent="submit"
    >
      <div class="form-body">
        <alert-box
          v-for="alert in alerts"
          :key="alert.message"
          :type="alert.type"
        >
          {{ alert.message }}
        </alert-box>

        <div class="row">
          <div class="col-md-12">
            <h6 class="request-item-title">
              {{ name }} ({{ returnReason }})
            </h6>
          </div>
        </div>

        <div class="damage-claim-specific-fields">
          <div class="row">
            <div class="col-md-6">
              <div class="file-upload-field">
                <div class="form-group">
                  <label
                    :for="`image-upload-${requestItemId}`"
                    :class="imageLabelCssClasses"
                  >
                    Step 1) Please upload an image of
                    how the item is {{ returnReason }}
                  </label>
                  <input
                    :id="`image-upload-${requestItemId}`"
                    ref="imageUpload"
                    type="file"
                    class="damage-image-upload"
                    @change="onFileUpload"
                  />
                </div>
                <div class="form-group">
                  <img
                    v-if="previewSrc"
                    :src="previewSrc"
                    alt="Image Upload Preview"
                    class="image-preview"
                    width="200px"
                    height="200px"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="file-upload-field">
                <div class="form-group">
                  <label
                    :for="`description-${requestItemId}`"
                    :class="descriptionLabelCssClasses"
                  >
                    Step 2) Please describe how
                    your item was {{ returnReason }}
                  </label>
                  <textarea
                    :id="`description-${requestItemId}`"
                    v-model="description"
                    cols="50"
                    rows="10"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <input
                  type="submit"
                  class="btn btn-primary"
                  :value="loading ? 'Please Wait' : 'Submit'"
                  :disabled="loading"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import axios from "axios"
  import alerts from "mixins/storefront/cart-alerts"

  export default {
    mixins: [alerts],
    props: {
      createPath: {
        type: String,
        required: true,
      },
      requestItemId: {
        type: Number,
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
      returnReason: {
        type: String,
        required: true,
      },
      descriptionRequired: {
        type: Boolean,
        required: true,
      },
      imageRequired: {
        type: Boolean,
        required: true,
      }
    },
    data() {
      return {
        loading: false,
        imageFile: null,
        description: null,
        previewSrc: null,
        successfullySubmitted: false,
      };
    },
    computed: {
      imageLabelCssClasses() {
        const classes = [];
        if (this.imageRequired) {
          classes.push("required")
        }
        return classes;
      },
      descriptionLabelCssClasses() {
        const classes = [];
        if (this.descriptionRequired) {
          classes.push("required")
        }
        return classes;
      },
      formData() {
        const data = new FormData();
        data.append("request_item_id", this.requestItemId);
        data.append("image", this.imageFile);
        data.append("description", this.description);
        return data;
      },
    },
    methods: {
      onFileUpload() {
        this.imageFile = this.$refs.imageUpload.files[0];
        const reader = new FileReader();
        reader.onload = () => {
          this.previewSrc = reader.result;
        };
        reader.readAsDataURL(this.imageFile)
      },
      validateForm() {
        let isValid = true;
        if (this.imageRequired && !this.imageFile) {
          this.alert("You must submit an image as evidence to your claim", "danger");
          isValid = false;
        }
        if (this.descriptionRequired && !this.description) {
          this.alert("You must submit a description as evidence to your claim", "danger");
          isValid = false;
        }
        return isValid;
      },
      submit() {
        this.alerts = [];

        if (!this.validateForm()) {
          return
        }

        this.loading = true;
        axios.post(
          this.createPath,
          this.formData,
        ).then((response) => {
          switch (response.status) {
            case 200:
              this.successfullySubmitted = true;
              break;
            case 422:
              response.data.errors.forEach((error) => {
                this.alert(error, "danger");
              });
              break;
            default:
              break;
          }
        }).catch((error) => {
          error.response.data.errors.forEach((dataError) => {
            this.alert(dataError, "danger");
          });
        }).finally(() => {
          this.loading = false;
        });
      },
    }
  };
</script>
